import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
} from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogConfig as MatDialogConfig,
  MatLegacyDialog as MatDialog,
} from '@angular/material/legacy-dialog';
import { GriddataService } from 'src/app/services/griddata.service';
import { DeleteBtnCellRender } from './review-container.component/delete-btn-cell-render';
import { EditBtnCellRender } from './review-container.component/edit-btn-cell-render';
import { DeleteBreaksComponent } from '../delete-breaks/delete-breaks.component';
import * as moment from 'moment';
import {
  warningMessage,
  successMessage,
} from 'src/app/constants';
import { Subject } from 'rxjs';
import { OspService } from 'src/app/core/master-services/osp.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EditBreaksComponent } from '../edit-breaks/edit-breaks.component';


@Component({
  selector: 'app-review-changes',
  templateUrl: './review-changes.component.html',
  styleUrls: ['./review-changes.component.scss'],
})
export class ViewBreakComponent implements OnInit {
  rowData: any[] = [];
  hasData: boolean = false;
  @ViewChild('osPartsGrid') osPartsGrid;
  columnDefs;
  defaultColDef;
  rowSelection;
  gridOptions = {} as any;
  //gridOptions!: GridOptions;
  paginationPageSize;
  paginationNumberFormatter;
  pagination = true;
  context: any;
  editType;
  suppressClickEdit = true;
  editEnabled: boolean = false;
  today = moment().format('MM/DD/YYYY');
  actionCellRenderer: any;
  gridApi: any;
  headerCheckboxChecked: boolean = false;
  isEditMode: boolean;
  warningMessage: string;
  successMessage: string;
  modalComponent = 'modal-component';
  public frameworkComponents
  itContact: string;
  namcValue = '';
  user = '';
  userRole = '';
  //add breaks
  isExpanded: boolean[] = []; // Declare and initialize here
  shiftNumber: any;
  userName = '';
  noRows: boolean = false;
  rows: any[] = [];
  rowData2: any[] = [];
  access;
  access1;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly gridDataService: GriddataService,
    private readonly dialogRef: MatDialogRef<ViewBreakComponent>,
    public dialog: MatDialog,
    private readonly ospService: OspService,
    private readonly spinner: NgxSpinnerService,

  ) {
    {
      this.context = {
        componentParent: this,
        refreshHeader: new Subject<void>()
      };
    }
    this.columnDefs = [
      {
        headerName: '',
        field: 'edit',
        colId: "action",
        sortable: false,
        unSortIcon: false,
        width: 55,
        pinned: 'left',
        editable: false,
        cellRendererFramework: EditBtnCellRender,
        cellRendererParams: {
          clicked: (field?: any) => {
            this.editeBreaks(field)
          },
        },
       
      },
      {
        headerName: '',
        field: 'delete',
        sortable: false,
        unSortIcon: false,
        pinned: 'left',
        width: 55,
        cellRendererFramework: DeleteBtnCellRender,
        cellRendererParams: {
          clicked: (field?: any) => {
            this.deleteButton(field)
          },
        },
        cellStyle: { cursor: 'pointer' },
      },
      {
        headerName: 'Shift No',
        field: 'shift_no',
        width: 140,
        editable: false,

      },
      {
        headerName: 'Break From',
        field: 'time_from',
        width: 160,
      },
      {
        headerName: 'To Break',
        field: 'time_to',
        width: 170,
      },

      
    ];
    this.defaultColDef = {
      editable: false
    };
    this.rowData = null;
    this.rowSelection = 'multiple';
    this.rowData = data
    this.getGridOptions();
  }

  getGridOptions() {
    this.gridOptions = {} as any;
    this.gridOptions = {
      frameworkComponents: {
        EditBtnCellRender: EditBtnCellRender,

      }};
    this.gridOptions.headerHeight = 38;

    this.gridOptions.rowHeight = 28;
    this.gridOptions.floatingFiltersHeight = 0;

    this.gridOptions.rowBuffer = 20;
    this.gridOptions.suppressMovableColumns = true;
    this.gridOptions.enableCellTextSelection = true;
    this.gridOptions.suppressContextMenu = false;
    this.gridOptions.suppressClipboardPaste = true;

    this.gridOptions.defaultColDef = {
      sortable: true,
      suppressMenu: true,
      filter: false,
      floatingFilter: false,

      wrapText: true,
      autoHeight: true,

      suppressPaste: false,

      floatingFilterComponentParams: { suppressFilterButton: true },
      unSortIcon: true,
      icons: {
        sortUnSort: '<img src="../../../assets/images/Rectangle8.svg">',
      },
      filterParams: {
        textCustomComparator(filter, value, filterText) {
          const filterTextLoweCase = filterText.toLowerCase();

          let valueLowerCase = '';
          if (value.params) {
            valueLowerCase = value.value.toString().toLowerCase();
          } else {
            valueLowerCase = value.toString().toLowerCase();
          }
          function contains(target, lookingFor) {
            if (target === null) {
              return false;
            }
            return target.indexOf(lookingFor) >= 0;
          }
          return contains(valueLowerCase, filterTextLoweCase);
        },

        debounceMs: 1000,

        caseSensitive: true,
        suppressAndOrCondition: true,
        inRangeInclusive: true,
      },
    };

    return this.gridOptions;
  }

  enableSave: boolean = false;
  ngOnInit() {
    this.access = JSON.parse(localStorage.getItem('shiftAccess1'));
    this.access1 = JSON.parse(localStorage.getItem('shiftAccess2'));

    if (this.data && this.data.rows ) {
      this.rowData = this.data.rows;
    }

    this.shiftNumber = this.data.rows[0]?.shift_no ?? this.data.result[0]?.shift_no;
    console.log(this.data,'329')
    console.log(this.shiftNumber,'shiftNumber')
    this.namcValue = localStorage.getItem('namcvalue');
    this.user = localStorage.getItem('workdayId');
    this.userRole = localStorage.getItem('UserRoles');
    this.userName = localStorage.getItem('UserName');
  }
 
  cellRendererFramework: EditBtnCellRender
 
  deleteButton(field: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '350px';
    dialogConfig.height = '200px';
    dialogConfig.data = {
      mode: 'Breaks',
    };
    console.log(dialogConfig.data,'delete breaks')
    const data1 = {
      offset: 0,
      limit: 1200,
      business_entity: this.namcValue,
      workid: this.user,
      userid: localStorage.getItem('UserName'),
      user_role: this.userRole,
      shift_id: field?.shift_id,
      break_id: field?.break_id,
      time_from:field?.time_from,
      time_to:field?.time_to,
      duration:field?.duration,
    };
    const dialogRef = this.dialog.open(DeleteBreaksComponent, dialogConfig)
    console.log(dialogRef, 'deleteBreaks')

    dialogRef.afterClosed().subscribe((res) => {
      if (res === 'cancel') {
        return;
      } else if (res === 'save') {
        this.spinner.show();
        this.ospService.getDeleteShiftBreaks(data1).subscribe({
          error: this.errorCallback,
          next: (data) => {
            if (data.body.breakDeletedCount >= 1) {
              const index = this.rowData.findIndex((item) =>
                item.break_id === data1?.break_id
              );
              if (index !== -1) {
                this.rowData.splice(index, 1);
              }
              this.gridOptions.api.setRowData(this.rowData);
              this.successMessage = successMessage.deleteRecord;
              this.spinner.hide();
            }
            else {
              this.warningMessage = `${warningMessage.apiLogicFail}  ${this.itContact}.`;
              this.spinner.hide();
            }
          },
        });
      }
    })
   
  }
  hideSpinner() {
    this.spinner.hide();
  }
  errorCallback = (error, apiName = '') => {
    console.error(error);
    this.hideSpinner();
    this.removeMessage();
  
    let detailedMessage = `${warningMessage.apiLogicFail} ${this.itContact}.`;
    const backendMessage = error?.error?.message || error?.message;
  
    if (backendMessage) {
      detailedMessage += ` | ${backendMessage}`;
    } else if (apiName) {
      detailedMessage += ` | Try after some time! Error in ${apiName}`;
    }
  
    this.warningMessage = detailedMessage;
  };
  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  };

  openBreaks() {
    this.removeMessage();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '450px';
    dialogConfig.height = '350px';
    dialogConfig.data = {
      shift_no:this.data.rows[0]?.shift_no ?? this.data.result[0]?.shift_no,
      shift_id:this.data.rows[0]?.shift_id ?? this.data.result[0]?.shift_id,
      dock:this.data.rows[0]?.dock ?? this.data.result[0]?.dock,
      duration:this.data.rows[0]?.duration ?? this.data.result[0]?.duration,
      startTime:this.data.rows[0]?.start_time ?? this.data.result[0]?.start_time,
      endTime:this.data.rows[0]?.end_time ?? this.data.result[0]?.end_time,
      mode: 'add',
      rowData: this.rowData
    };
    console.log(dialogConfig.data, 'add_1277')
    
    const dialogRef = this.dialog.open(EditBreaksComponent, dialogConfig,);
    console.log(dialogRef.componentInstance.addBreaksEventEmitter,'componentInstance');
    const addGetResponse =
      dialogRef.componentInstance?.addBreaksEventEmitter?.subscribe({error: this.errorCallback,
        next:(res) => {
        console.log("res---",res);
       
        const data1 = {
          business_entity: this.namcValue,
          workid: this.user,
          user_role: this.userRole,
          userid: this.userName,
          dock: this.data.rows[0]?.dock ?? this.data.result[0]?.dock,
          shift_no: res.shiftNumber,
          shift_id: this.data.rows[0]?.shift_id ?? this.data.result[0]?.shift_id,
          start_time: res.fromTimeNew,
          end_time: res.toTimeNew,
          duration:this.data.rows[0]?.duration ?? this.data.result[0]?.duration,
          plant: this.namcValue,
        }
        this.spinner.show();
        this.ospService?.addBreak(data1)?.subscribe({
          error: (error) => this.errorCallback(error,'addBreak'),
          next: (response) => {
            this.spinner.hide();
            const updatedRows  =  true;
            if (updatedRows) {
              this.rowData.push(response.body.updatedRows[0]);
              this.successMessage = successMessage.shiftBreaksAdded;
              function timeToMinutes(timeStr) {
                const [h, m, s] = timeStr.split(":").map(Number);
                return h * 60 + m;
              }
              
              function getShiftLabel(timeStr) {
                const minutes = timeToMinutes(timeStr);
                if (minutes >= 300 && minutes < 840) return "Morning";     // 05:00–13:59
                if (minutes >= 840 && minutes < 1320) return "Evening";     // 14:00–21:59
                return "Night";                                             // 22:00–04:59
              }
              
              function getShiftOrder(shiftName) {
                return { Morning: 1, Evening: 2, Night: 3 }[shiftName];
              }
              
              function sortByShiftAndTime(rowData) {
                return rowData
                  .map(row => ({
                    ...row,
                    shift: getShiftLabel(row.time_from)
                  }))
                  .sort((a, b) => {
                    const shiftA = getShiftOrder(a.shift);
                    const shiftB = getShiftOrder(b.shift);
                    if (shiftA !== shiftB) return shiftA - shiftB;
              
                    // same shift, sort by time_from
                    return timeToMinutes(a.time_from) - timeToMinutes(b.time_from);
                  });
              }
              
              
              // Usage
              this.rowData = sortByShiftAndTime(this.rowData);
              
              this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
            } else {
              this.warningMessage = `${warningMessage.reportsNotUpdated}  ${this.itContact}.`;
            }
   
            window.scroll(0, 0);
          },
        });
      }});
    dialogRef.afterClosed().subscribe((res) => {
      addGetResponse.unsubscribe();
    });
  }

  convertMinutesToTimeFormat(minutes) {
    // Convert total minutes into HH:MM:SS format
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const seconds = 0; // Assuming zero seconds
    return `${this.padZero(hours)}:${this.padZero(mins)}:${this.padZero(seconds)}`;
  }

  padZero(num) {
    // Pad single digit numbers with a leading zero (e.g., 9 -> 09)
    return num < 10 ? `0${num}` : num.toString();
  }



  


  editeBreaks(field: any) {
    this.removeMessage();
  
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '450px';
    dialogConfig.height = '350px';
    dialogConfig.data = {
      field,
      shift_no: field.shift_no,
      toTime: field.time_to,
      fromTime: field.time_from,
      endtime: field.start_time,
      mode: 'edit',
      rowData:this.rowData
    };
  
    const oldBreakDuration = this.convertTimeToMinutes(field.time_to) - this.convertTimeToMinutes(field.time_from);
    console.log("Old Break Duration:", oldBreakDuration);
  
    const dialogRef = this.dialog.open(EditBreaksComponent, dialogConfig);
  
    const addGetResponse = dialogRef.componentInstance?.editBreaksEventEmitter?.subscribe({
      error: this.errorCallback,
      next: (res) => {
        const newBreakDuration = this.convertTimeToMinutes(res.toTimeNew) - this.convertTimeToMinutes(res.fromTimeNew);
        console.log("New Break Duration:", newBreakDuration);
  
        const finalDuration = field.duration + (oldBreakDuration - newBreakDuration);
        console.log("Updated Final Duration:", finalDuration);
  
        const updatedBreakData = {
          business_entity: this.namcValue,
          workid: this.user,
          user_role: this.userRole,
          userid: this.userName,
          dock: field.dock,
          shift_no: res.shiftNumber,
          shift_id: field.shift_id,
          start_time: res.fromTimeNew,
          end_time: res.toTimeNew,
          break_id: field.break_id,
          duration: finalDuration,
        };
  
        const payload = {
          data: [updatedBreakData],
          business_entity: this.namcValue,
          workid: this.user,
          user_role: this.userRole,
          userid: this.userName,
          dock: field.dock,
          shift_no: res.shiftNumber,
          shift_id: field.shift_id,
          plant: '01',
          duration: finalDuration,
          break_id: field.break_id,
        };
  
        this.spinner.show();
  
        this.ospService?.editBreak(payload)?.subscribe({
          error: (error) => this.errorCallback(error, 'editBreak'),
          next: (response) => {
            this.spinner.hide();
  
            const updatedRows = response.body?.updatedRows;
            if (updatedRows && updatedRows.length > 0) {
              this.successMessage = successMessage.shiftBreaksUpdated;
  
              const updatedBreakId = payload.data[0].break_id;
              const index = this.rowData.findIndex(item => item.break_id === updatedBreakId);
  
              if (index !== -1) {
                this.rowData[index] = updatedRows[0];
                
                // function sortRowDataWithMidnightShift(rowData) {
                //   return rowData.sort((a, b) => {
                //     const fromA = parseTimeToMinutes(a.time_from);
                //     const toA = parseTimeToMinutes(a.time_to);
                //     const fromB = parseTimeToMinutes(b.time_from);
                //     const toB = parseTimeToMinutes(b.time_to);
                
                //     // Adjust for overnight shifts (e.g., 22:00 to 06:00)
                //     const durationA = toA >= fromA ? toA - fromA : (1440 - fromA + toA);
                //     const durationB = toB >= fromB ? toB - fromB : (1440 - fromB + toB);
                
                //     // First sort by start time
                //     if (fromA !== fromB) {
                //       return fromA - fromB;
                //     }
                
                //     // If same start time, sort by adjusted duration
                //     return durationA - durationB;
                //   });
                // }

                function timeToMinutes(timeStr) {
                  const [h, m, s] = timeStr.split(":").map(Number);
                  return h * 60 + m;
                }
                
                function getShiftLabel(timeStr) {
                  const minutes = timeToMinutes(timeStr);
                  if (minutes >= 300 && minutes < 840) return "Morning";     // 05:00–13:59
                  if (minutes >= 840 && minutes < 1320) return "Evening";     // 14:00–21:59
                  return "Night";                                             // 22:00–04:59
                }
                
                function getShiftOrder(shiftName) {
                  return { Morning: 1, Evening: 2, Night: 3 }[shiftName];
                }
                
                function sortByShiftAndTime(rowData) {
                  return rowData
                    .map(row => ({
                      ...row,
                      shift: getShiftLabel(row.time_from)
                    }))
                    .sort((a, b) => {
                      const shiftA = getShiftOrder(a.shift);
                      const shiftB = getShiftOrder(b.shift);
                      if (shiftA !== shiftB) return shiftA - shiftB;
                
                      // same shift, sort by time_from
                      return timeToMinutes(a.time_from) - timeToMinutes(b.time_from);
                    });
                }
                
                
                // Usage
                this.rowData = sortByShiftAndTime(this.rowData);
                
                this.gridOptions.api.setRowData([...this.rowData]);
              }
            } else {
              this.warningMessage = `${warningMessage.reportsNotUpdated} ${this.itContact}.`;
            }
  
            window.scroll(0, 0);
          },
        });
      },
    });
  
    dialogRef.afterClosed().subscribe(() => {
      addGetResponse?.unsubscribe();
    });
  }


  convertTimeToMinutes(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    let totalMinutes = (hours * 60) + minutes;
    
    // If time is past midnight, adjust for the next day
    if (hours < 6) { // Example: If time is before 6 AM, consider it as next day
      totalMinutes += 24 * 60;  // Add 24 hours (1440 minutes)
    }
  
    return totalMinutes;
  }
  
  
}

